<template>
    <Card :title="$t('labels.payment')">
        <form @submit.prevent="submit">
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-3">
                        <FormGroup :label="$t('labels.type')">
                            <AppSelect
                                :model-value="type?.value"
                                :selected-value="type?.label"
                                @update:model-value="type = $event"
                                :options="orderPaymentTypeOptions"
                                option-key="value"
                                option-value="label"
                            />
                        </FormGroup>
                    </div>
                    <div class="col-lg-3">
                        <FormGroup :label="$t('labels.comment')">
                            <Input v-model="comment" />
                        </FormGroup>
                    </div>
                    <div class="col-lg-3">
                        <FormGroup :label="$t('labels.sum')">
                            <Input v-model="sum" type="number" />
                        </FormGroup>
                    </div>
                    <div class="col-lg-3">
                        <FormGroup :label="$t('labels.status')">
                            <AppSelect
                                :model-value="is_paid.value"
                                :selected-value="is_paid.label"
                                @update:model-value="is_paid = $event"
                                :options="[
                                    { value: true, label: $t('labels.paid') },
                                    { value: false, label: $t('labels.not_paid') }
                                ]"
                                option-key="value"
                                option-value="label"
                            />
                        </FormGroup>
                    </div>
                </div>
            </div>
            <div class="card-footer d-flex justify-content-end">
                <AppButton color="indigo" type="submit">
                    <i class="icon-floppy-disk mr-2"></i>
                    {{ $t('buttons.edit') }}
                </AppButton>
            </div>
        </form>
    </Card>
</template>
<script>
import Card from '../../../../../components/new/CardComponent.vue';
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../components/new/form/Input.vue';
import AppSelect from '../../../../../components/new/form/select/AppSelect.vue';
import AppButton from '../../../../../components/new/button/AppButton.vue';

import { OrderPaymentTypeEnum } from '../../../../enums/OrderPaymentTypeEnum';
import { httpClient } from '../../../../../services/HttpClient';
import MessageNotificator from '../../../../../services/MessageNotificator';

export default {
    name: "OrderPaymentEditPage",
    components: {
        Card, FormGroup, Input, AppSelect, AppButton
    },
    emits: ['update'],
    data() {
        return {
            comment: '',
            sum: null,
            is_paid: { value: false, label: this.$t('labels.not_paid') },
            type: null,
            orderPaymentTypeOptions: [
                { value: OrderPaymentTypeEnum.BANK_TRANSFER, label: this.$t('enums.OrderPaymentTypeEnum.bank_transfer') },
                { value: OrderPaymentTypeEnum.CASH, label: this.$t('enums.OrderPaymentTypeEnum.cash') },
                { value: OrderPaymentTypeEnum.CARD_ONLINE, label: this.$t('enums.OrderPaymentTypeEnum.card_online') },
                { value: OrderPaymentTypeEnum.CASH_ON_DELIVERY, label: this.$t('enums.OrderPaymentTypeEnum.cash_on_delivery') },
                { value: OrderPaymentTypeEnum.INSTALLMENTS, label: this.$t('enums.OrderPaymentTypeEnum.installments') },
            ]
        }
    },
    methods: {
        async submit() {
            await httpClient.patch(`/projects/${this.$route.params.projectUuid}/crm/orders/${this.$route.params.orderUuid}/payments/${this.$route.params.orderPaymentUuid}`, {
                comment: this.comment,
                sum: this.sum,
                is_paid: this.is_paid.value,
                type: this.type.value
            }).then(() => {
                this.$emit('update');
                this.$router.replace({ name: 'OrderPaymentsPage' });
                new MessageNotificator().success(this.$t('messages.success'));
            });
        },
        fetchOrderPayment() {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/crm/orders/${this.$route.params.orderUuid}/payments/${this.$route.params.orderPaymentUuid}`).then(response => {
                const payment = response.data.data;

                this.comment = payment.comment;
                this.sum = payment.sum;
                this.is_paid = { value: payment.is_paid, label: payment.is_paid ? this.$t('labels.paid') : this.$t('labels.not_paid') };
                this.type = this.orderPaymentTypeOptions.find(option => option.value === payment.type);
            });
        }
    },
    mounted() {
        this.fetchOrderPayment();
    }
}
</script>